import { PropsWithChildren } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { PageWithHeader } from '@backstage/core-components';

export const TechDocsIndexPageWrapper = (props: PropsWithChildren<{}>) => {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';

  return (
    <PageWithHeader title={`${orgName} Docs`} themeId="documentation">
      {props.children}
    </PageWithHeader>
  );
};
